module.exports = __webpack_public_path__ + "img/connect-3.6dd9684f.svg";